import { render, staticRenderFns } from "./approverEdit.vue?vue&type=template&id=64ae8e12&scoped=true"
import script from "./approverEdit.vue?vue&type=script&lang=js"
export * from "./approverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae8e12",
  null
  
)

export default component.exports